"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Path_1 = require("../Util/Path");
const configs_1 = require("../configs/configs");
class AnsweredQuestionnaireRepository {
    constructor(config, httpClient, questionnaireTransformer, errorTransformer) {
        this.config = config;
        this.httpClient = httpClient;
        this.transformer = questionnaireTransformer;
        this.errorTransformer = errorTransformer;
        this.axiosErrorTransformer = errorTransformer;
    }
    static create(config, container) {
        return new this(config, container.get('http_client'), container.get("transformer.answered_questionnaire_to_data"), container.get('transformer.axios_to_error'));
    }
    /**
     * @inheritDoc
     */
    create(valuation, questionnaireMachineName, answeredQuestions) {
        const url = Path_1.default.route(configs_1.configs.endpoints.answeredQuestionnaire, {
            token: valuation.getToken(),
            id: questionnaireMachineName,
            lang: this.config.getWidgetLang(),
        });
        return this.httpClient.post(url, answeredQuestions)
            .catch(err => {
            throw this.errorTransformer.to(err);
        })
            .then((res) => {
            const answeredQuestionnaire = this.transformer.from(res.data);
            // Remove older answered questionnaires, keep only the latest one
            let currentQstrs = valuation.getAnsweredQuestionnaires();
            let duplicateQstr = currentQstrs.find((qstr) => {
                return qstr.getId() === answeredQuestionnaire.getId();
            });
            if (duplicateQstr) {
                currentQstrs.remove(duplicateQstr);
            }
            currentQstrs.add(answeredQuestionnaire);
            valuation.setAnsweredQuestionnaires(currentQstrs);
            return answeredQuestionnaire;
        });
    }
}
exports.default = AnsweredQuestionnaireRepository;
Mixin_1.default(AnsweredQuestionnaireRepository, IContainerInjection_1.default);
